export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND';

export const UNAUTHENTICATED_CODE = 401;
export const FORBIDDEN_CODE = 403;
export const NOT_FOUND_CODE = 404;
export const UNPROCESSABLE_CONTENT_CODE = 422;
